import GoogleAnalytics from '@libs/GoogleAnalytics';

export default {
  install: Vue => {
    Vue.prototype.$ga = GoogleAnalytics;
    window.ga = GoogleAnalytics;
  },
};
